import React, { Component, Fragment } from 'react';
import { PropTypes } from 'prop-types';
import moment from 'moment-timezone';

import handleFormLanguageTab from '../../../utils/handleFormLanguageTab';
import getArtistSet from '../../../api/graphql/queries/getArtistSet';
import getPostBySlug from '../../../api/graphql/queries/getPostBySlug';

import FormInput from '../../Form/FormInput';
import FormTags from '../../Form/FormTags';
import ArtistLanguageTabsContainer from './ArtistLanguageTabsContainer';
import DeleteModal from '../../Modal/DeleteModal';
import Autocomplete from '../../Form/Autocomplete';
import DateAndTimePicker from '../../Form/DateAndTimePicker';

import slugify from '../../../utils/slugify';

const timezones = {
  losAngeles: 'America/Los_Angeles',
  porto: 'Europe/Lisbon',
  barcelona: 'Europe/Madrid',
  saoPaulo: 'America/Fortaleza',
  santiago: 'America/Santiago',
  buenosAires: 'America/Buenos_Aires',
};

class ArtistForm extends Component {
  state = {
    canSubmit: false,
    tabsInfo: {},
    slugName: '',
    slugError: true,
    artistSlugName: '',
    venueSlugName: '',
    show: false,
    showDate: false,
    showDateTime: false,
    showTicket: false,
    showVenue: false,
    artistSetGenres: [],
  };

  getTabsInfo = (state) => {
    this.setState({ tabsInfo: state });
  };

  componentDidMount() {
    const { formInput, action } = this.props;
    console.log('formInput', formInput);
    if (formInput && action !== 'create') {
      this.setState({
        show: formInput.show,
        showDate: formInput.showDate,
        showDateTime: formInput.showDateTime,
        showTicket: formInput.showTicket,
        showVenue: formInput.showVenue,
        duration: formInput.duration,
        artistSetGenres: formInput.artistSetGenres,
        stock: formInput.stock,
      });
    }
  }

  submit = async () => {
    // const adjustTags = () => {
    //   const { tags } = this.state;
    //   if (tags) {
    //     if (tags.length > 3) {
    //       if (tags.indexOf(',') === -1) {
    //         return tags.split(' ');
    //       }
    //       return tags.replace(/ /g, '').split(',');
    //     }
    //     return tags.replace(/ /g, '').split(',');
    //   }
    //   return null;
    // };

    // const tagsArray = adjustTags();

    const { tabsInfo } = this.state;
    const {
      artistSetName, countryCode, slugName, itunes, video, web, disco, venueSlugName, artistSlugName, show, beginTimeReal, beginTimeHuman, endTime, duration, artistSetGenres, stock,
    } = this.state;
    const { formInput, artistSlugNamesToArtistName, action } = this.props;
    const artistSlugNameForm = (artistSlugName && artistSlugName.toLowerCase()) || (formInput && formInput.artistSlugName.toLowerCase()) || '';
    const artistPost = await getPostBySlug(artistSlugNameForm);
    const artistName = (artistPost && artistPost.postDescription && artistPost.postDescription.title && artistPost.postDescription.title.en) || '';
    const ArtistSetData = {};
    if (action === 'modify') {
      ArtistSetData.id = (formInput && formInput._id) || '';
    }
    ArtistSetData.artistSetSlugName = slugName || formInput.artistSetSlugName.toLowerCase();
    ArtistSetData.postUri = `/${(artistSlugName && artistSlugName.toLowerCase()) || (formInput && formInput.artistSlugName.toLowerCase()) || ''}`;
    ArtistSetData.artistSetName = (artistSetName && artistSetName.toLowerCase()) || formInput.artistSetName.toLowerCase();
    ArtistSetData.venueSlugName = (venueSlugName && venueSlugName.toLowerCase()) || (formInput && formInput.venueSlugName.toLowerCase()) || '';
    ArtistSetData.artistSlugName = (artistSlugName && artistSlugName.toLowerCase()) || (formInput && formInput.artistSlugName.toLowerCase()) || '';
    ArtistSetData.artistName = (artistName && artistName[artistSlugName.toLowerCase()]) || (formInput && formInput.artistName) || '';
    ArtistSetData.mediaLinks = {
      itunes: itunes || (formInput && formInput.mediaLinks?.itunes) || '',
      video: video || (formInput && formInput.mediaLinks?.video) || '',
      web: web || (formInput && formInput.mediaLinks?.web) || '',
      disco: disco || (formInput && formInput.mediaLinks?.disco) || '',
    };
    ArtistSetData.countryCode = countryCode || (formInput && formInput.countryCode) || '';
    ArtistSetData.artistSetGenres = artistSetGenres || [];
    // ArtistSetData.tags = tagsArray || FormInput.tags || [''];
    ArtistSetData.image = handleFormLanguageTab('imageObj', tabsInfo);
    ArtistSetData.artistSetReadableName = handleFormLanguageTab('artistSetReadableName', tabsInfo) || {
      en: artistSetName || '',
    };
    ArtistSetData.shortTitle = handleFormLanguageTab('shortTitle', tabsInfo);
    ArtistSetData.smallText = handleFormLanguageTab('smallText', tabsInfo);

    // ArtistSetData.image = {
    //   en: tabsInfo.imageEN || (formInput && formInput.hasOwnProperty('image') && formInput.image !== null && formInput.image.en) || '',
    //   es: tabsInfo.imageES || (formInput && formInput.hasOwnProperty('image') && formInput.image !== null && formInput.image.es) || '',
    //   ca: tabsInfo.imageCA || (formInput && formInput.hasOwnProperty('image') && formInput.image !== null && formInput.image.ca) || '',
    //   pt: tabsInfo.imagePT || (formInput && formInput.hasOwnProperty('image') && formInput.image !== null && formInput.image.pt) || '',
    // };
    // defaulted to start date, we will use duration for our calculations
    ArtistSetData.dateTimeEndReal = beginTimeReal || (formInput && formInput.dateTimeStartReal);
    ArtistSetData.dateTimeStartReal = beginTimeReal || (formInput && formInput.dateTimeStartReal);
    ArtistSetData.dateTimeStartHuman = beginTimeHuman || (formInput && formInput.dateTimeStartHuman);

    ArtistSetData.duration = parseInt(duration) || 0;
    ArtistSetData.stock = parseInt(stock) || 0;
    // must be booleans
    ArtistSetData.show = show || false;

    const { retrieveOutput } = this.props;
    retrieveOutput(ArtistSetData, action);

    const { handleClick } = this.props;
    handleClick(action);
  };

  enableButton = () => {
    const { artistSetName } = this.state;
    if (artistSetName) {
      return this.setState({ canSubmit: true });
    }
    return this.setState({ canSubmit: false });
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  updateSlugName = (slugName) => {
    this.setState({ slugName });
  };

  storeText = async (currField, value) => {
    if (currField === 'artistSetName') {
      const slugName = slugify(value);
      this.updateSlugName(slugName);
      const getSingleArtistSetQueryResult = await getArtistSet(slugName);
      const { artistSetSlugName: existingArtistSet = '' } = getSingleArtistSetQueryResult;
      if (existingArtistSet && existingArtistSet.length) {
        console.log('item already exists in the DB');
        this.setState({ slugError: true, canSubmit: false });
      } else {
        if (slugName.length) {
          this.setState({ slugError: false, canSubmit: true });
        } else {
          this.setState({ canSubmit: false });
        }
      }
    }
    this.setState({ [currField]: value });
  };

  storeGenre = (currField, genres) => {
    const arr = genres.toUpperCase().replace(/,/g, '').split(' ').filter(Boolean);
    this.setState({ artistSetGenres: arr });
  };

  handleDate = (name, date) => {
    const utcStrippedDate = moment(date).format('YYYY-MM-DDTHH:mm:ss');

    const formattedDate = moment.tz(utcStrippedDate, timezones.madrid).format();

    this.setState({
      [name]: formattedDate,
    });
  };

  render() {
    const {
      canSubmit, slugName, slugError, show, isModalOn,
    } = this.state;
    const {
      handleClick, formInput, action, handleDelete, isDeleteInfoScreenOpen, canItemBeDeleted, venuesSlugNames, artistSlugNames, closeToggleDelete,
    } = this.props;

    return (
      <Fragment>
        <div className="bg-black text-white p-4">
          <div className="login">
            <div className="w-full">
              <FormInput name="artistSetName" title="Artist Set Name" storeText={this.storeText} slugError={slugError} action={action} value={(formInput && formInput.artistSetName) || ''} slugValidation="slugValidation" onBlur={this.enableButton} />
              <div className="font-americaMonoRegular text-xs mb-4 -mt-2">{`/${slugName || (formInput && formInput.artistSetSlugName) || ''}`}</div>
            </div>
            <Autocomplete title="Venue Slugname" name="venueSlugName" message="The venue slug does not exist" suggestions={venuesSlugNames} storeText={this.storeText} action={action} value={formInput && formInput.venueSlugName?.toUpperCase()} />
            <Autocomplete title="Artist Slugname" name="artistSlugName" message="The artist slug does not exist" suggestions={artistSlugNames} storeText={this.storeText} action={action} value={formInput && formInput.artistSlugName?.toUpperCase()} />
            {/* {(action === 'display' || action === 'delete') && <FormInput name="tags" title="Tags" value={formInput.tags && formInput.tags.toString()} action={action} />}
            {(action === 'create' || action === 'modify') && <FormTags name="tags" title="Tags" tag="" action={action} tagsToModify={formInput && formInput.tags} storeText={this.storeText} />} */}
            <div className="bg-greyWithinForm mb-4">
              <ArtistLanguageTabsContainer getTabsInfo={this.getTabsInfo} action={action} sendTabsInfo={formInput && formInput} />
            </div>
            <FormInput name="countryCode" title="Country Code" action={action} storeText={this.storeText} value={(formInput && formInput.countryCode) || ''} />
            <FormInput name="genre" title="Genre (space bar between words for multiple records)" action={action} storeText={this.storeGenre} value={(formInput && formInput.hasOwnProperty('artistSetGenres') && formInput.artistSetGenres !== null && formInput.artistSetGenres.length && formInput.artistSetGenres.toString().replace(/,/gi, ' ')) || ''} />
            <div className="w-full flex items-center -my-5">
              <DateAndTimePicker title="Begin Time Real" name="beginTimeReal" handleDate={this.handleDate} existingDate={formInput && formInput.dateTimeStartReal} action={action} timezone={timezones.losAngeles} />
              <div className="ml-8" />
              <DateAndTimePicker title="Begin Time Human" name="beginTimeHuman" handleDate={this.handleDate} existingDate={formInput && formInput.dateTimeStartHuman} action={action} timezone={timezones.losAngeles} />
              {/* <DateAndTimePicker title="End Time" name="endTime" handleDate={this.handleDate} existingDate={formInput && formInput.dateTimeEndReal} action={action} /> */}
              <div className="ml-8" />
              <div className="flex">
                <FormInput name="duration" title="Duration in minutes" action={action} storeText={this.storeText} value={(formInput && formInput?.duration) || '0'} />
              </div>
            </div>
            <div className="flex w-full">
              <div className="w-full">
                <FormInput name="itunes" title="Itunes Media Link" action={action} storeText={this.storeText} value={(formInput && formInput.mediaLinks?.itunes) || ''} />
              </div>
              <div className="pl-2 w-full">
                <FormInput name="video" title="Video Media Link" action={action} storeText={this.storeText} value={(formInput && formInput.mediaLinks?.video) || ''} />
              </div>
            </div>
            <div className="flex w-full">
              <div className="w-full">
                <FormInput name="web" title="Web Media Link" action={action} storeText={this.storeText} value={(formInput && formInput.mediaLinks?.web) || ''} />
              </div>
              <div className="pl-2 w-full">
                <FormInput name="disco" title="Disco Media Link" action={action} storeText={this.storeText} value={(formInput && formInput.mediaLinks?.disco) || ''} />
              </div>
            </div>
            <div className="flex w-full">
              <div className="w-full">
              <FormInput name="stock" title="Stock" action={action} storeText={this.storeText} value={(formInput && formInput.stock) || '0'} />
              </div>
            </div>
            <div className="flex w-full justify-start -ml-8">
              <label className="flex flex-col font-americaMonoRegular text-xs w-1/8 justify-center uppercase text-white pt-0 items-center">
                Show ArtistSet
                <div className="mt-2 pb-0 mr-1 -ml-3">
                  <label className="switch mb-0 pb-0 h-6">
                    <input className="switch" checked={show} onChange={() => this.setState({ show: !show })} type="checkbox" disabled={action === 'display' || action === 'delete'} />
                    <div className="switch-slider btn-yn1 switch-round" />
                  </label>
                </div>
              </label>
            </div>
            <div className="flex justify-end my-2">
              <button type="button" className="font-americaMonoBold text-xs px-6 py-2 rounded-full border-white border-1 bg-black text-white uppercase ml-7 mt-2 w-110px" onClick={() => handleClick(action)}>
                Cancel
              </button>
              {action !== 'display' && action !== 'delete' && (
                <button
                  onClick={this.submit}
                  className={`font-americaMonoBold text-xs px-6 py-2 rounded-full uppercase ml-7 mt-2 w-110px text-black rounded-full py-2 px-4
                 ${canSubmit || action === 'modify' ? 'bg-white ' : 'bg-grey '} ${action === 'delete' && 'bg-red text-white'}`}
                  type="submit"
                  disabled={action === 'modify' ? canSubmit : !canSubmit}
                >
                  {`${(action === 'create' && 'Submit') || (action === 'modify' && 'Change') || (action === 'delete' && 'Delete')}`}
                </button>
              )}
              {action === 'delete' && (
                <button
                  type="button"
                  className="bg-red text-white font-americaMonoBold text-xs px-6 py-2 rounded-full uppercase ml-7 mt-2 w-110px text-black rounded-full py-2 px-4"
                  onClick={() => {
                    handleDelete(formInput._id, formInput.artistSetSlugName);
                  }}
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        </div>
        {isDeleteInfoScreenOpen ? (
          canItemBeDeleted ? (
            <DeleteModal zIndex="20" title="Item to be deleted" handleClick={() => handleClick('delete')} closeToggleDelete={closeToggleDelete}>
              {`${formInput.artistSetName} has been deleted`}
            </DeleteModal>
          ) : (
            <DeleteModal zIndex="20" title="Item cannot be deleted" handleClick={() => handleClick('delete')} closeToggleDelete={closeToggleDelete}>
              {`${formInput.artistSetName} has other records linked to it and it cannot be deleted.`}
            </DeleteModal>
          )
        ) : null}

      </Fragment>
    );
  }
}

ArtistForm.propTypes = {
  handleClick: PropTypes.func.isRequired,
  retrieveOutput: PropTypes.func,
  formInput: PropTypes.shape({}),
  action: PropTypes.string,
  handleDelete: PropTypes.func,
  isDeleteInfoScreenOpen: PropTypes.bool,
  canItemBeDeleted: PropTypes.bool,
  venuesSlugNames: PropTypes.arrayOf(PropTypes.string),
  artistSlugNames: PropTypes.arrayOf(PropTypes.string),
  artistSlugNamesToArtistName: PropTypes.arrayOf(PropTypes.shape()),
  closeToggleDelete: PropTypes.func,
};

ArtistForm.defaultProps = {
  formInput: null,
  action: '',
  retrieveOutput: null,
  handleDelete: null,
  isDeleteInfoScreenOpen: false,
  canItemBeDeleted: false,
  venuesSlugNames: [],
  artistSlugNames: [],
  artistSlugNamesToArtistName: [],
  closeToggleDelete: null,
};

export default ArtistForm;
